import { skipToken, useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches a patient's membership invoices and appointment penalty fees. */
export function useGetPatientInvoices(patientId: string | undefined) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient', patientId, 'invoices'],
    queryFn:
      patientId === undefined
        ? skipToken
        : async () => {
            const response = await api.get('/patients/:patientId/invoices', {
              params: { patientId },
            })
            if (!response.success) throw new Error(response.error.message)
            return response.data.invoices
          },
    staleTime: 60_000,
  })
}
